module.exports = __webpack_public_path__ + "img/logo1@2x.6a3b10db.png";